import * as Yup from "yup";
import TextField from "../../../../common/components/formFields/TextField";

export function formFields(t) {
  return [
    {
      size: 12,
      field: (
        <TextField
          id="designation"
          type="designation"
          label={t("structure.ZoneForm.form.designation")}
          required={true}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          id="description"
          type="description"
          label={t("structure.ZoneForm.form.description")}
        />
      ),
    },
  ];
}

export function formSchema(t) {
  return Yup.object().shape({
    designation: Yup.string().required(t("structure.ZoneForm.form.requiredDesignation")),
    description: Yup.string(),
  });
}